"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var modal_1 = __importDefault(require("./modal"));
exports.default = (0, react_router_dom_1.withRouter)((0, react_redux_1.connect)(function (state, ownProps) {
    return {
        isAuthorized: state.user.userIsLogged,
        userInfo: state.user.userInfo,
    };
})(SuccessModal));
function SuccessModal(props) {
    var user = props.user;
    return ((0, jsx_runtime_1.jsx)(modal_1.default, { size: "mini", title: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Preinscripci\u00F3n ", (0, jsx_runtime_1.jsx)("br", {}), " realizada exitosamente"] }), open: props.open, close: props.openModal, showIcon: true, showBtn: true, btnText: "Entendido", btnAction: props.openModal, customClass: "successModal", content: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("p", { children: ["Te has preinscrito exitosamente, ahora recibir\u00E1s las \u00FAltimas novedades de ", (0, jsx_runtime_1.jsx)("b", { children: user === null || user === void 0 ? void 0 : user.first_name })] }) }) }));
}
